import { useState,useRef } from 'react'

import './button.scss'

type ExplorerPorps = {
  title?: string
  icon?: any
  click: () => void
  size?: 'small'
  style?: any,
  activeInactive?: boolean
  disabled?: boolean,
  dropdown?: Array<{ title: string, onClick: () => void }>
  dropdownPosition?: 'bottomLeft'
}

function Button(props: Readonly<ExplorerPorps>) {
  const catMenu = useRef<HTMLDivElement  | null>(null)
  const [dropdown, setDropdown] = useState(false)

  const closeOpenMenus = (e: any)=>{
    if(dropdown && !catMenu.current?.contains(e.target)){
      setDropdown(false)
    }
  }

  if(props.dropdown) {
    document.addEventListener('mousedown',closeOpenMenus)
    return (
      <div ref={catMenu} style={{ position: 'relative' }}>
        {props.icon ? (
          <button
            style={props.style}
            className={`button-icon${props.size ?  '-' + props.size : null}`}
            onClick={(e) => {e.stopPropagation(); setDropdown(!dropdown)}}
            disabled={props.disabled}>
            {props.icon}
          </button>
        ) : (
          <button
            className={`${props.size ? 'button-' + props.size : ''}`}
            style={props.style}
            onClick={(e) => {e.stopPropagation(); setDropdown(!dropdown)}}
            disabled={props.disabled}
          >
            {props.title}
          </button>
        )}
       
        {dropdown && <div className='dropdown' style={props.dropdownPosition  === 'bottomLeft' ? { right: 0 } : {}}>

          {props.dropdown.map((link) => {
            return (
            <button 
              key={link.title}
              onClick={() => {
                link.onClick()
                setDropdown(false)
              }} 
              className='dropdown-link'
            >
              {link.title}
            </button>
          )
          })}

        </div>}
      </div>
    )
  }

  if(props.activeInactive !== undefined) {
    return (
      <button
        className={`activeInactive ${props.size ? 'button-' + props.size : ''} ${props.activeInactive ? 'activeInactiveActive' : ''}`}
        style={props.style}
        onClick={(e) => {e.stopPropagation(); props.click()}}
        disabled={props.disabled}
      >
        {props.title}
      </button>
    )
  }

  if(props.icon) {
    return (
      <button style={props.style} className={`button-icon${props.size ?  '-' + props.size : null}`} onClick={(e) => {e.stopPropagation(); props.click()}} disabled={props.disabled}>
        {props.icon}
      </button>
    )
  }

  return (
    <button
      className={`${props.size ? 'button-' + props.size : ''}`}
      style={props.style}
      onClick={(e) => {e.stopPropagation(); props.click()}}
      disabled={props.disabled}
    >
      {props.title}
    </button>
  )
}

export default Button
